<template>
    <div v-if="mostrar" style="overflow: auto" class="modal-mask" @click="$emit('fechar')">
        <div style="height: 50%; width: 50rem; padding: 2rem; margin-bottom: 3rem;" class="jm" @click.stop>
            <div>
                <div style="display: flex; justify-content: space-between">
                    <h3>Editar: {{ localPrograma.nome }} </h3>
                </div>
                <hr>
                <br>
                <div class="grid-2">
                    <div>
                        <label>Nome do Projeto</label>
                        <input type="text" v-model="localPrograma.nome"
                            @focusout="$emit('editar', 'nome', localPrograma.nome)">
                    </div>
                    <div>
                        <label>Gerente Responsável</label>
                        <select @focusout="$emit('editar', 'gerente_id', localPrograma.gerente_id)"
                            v-model="localPrograma.gerente_id">
                            <option v-for="item in gerente" :key="item.id" :value="item.id">
                                {{ item.nomeCompleto }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <label>Data de Início</label>
                        <input type="date" v-model="localPrograma.dtInicio"
                            @change="$emit('editar', 'dtInicio', $event.target.value)">
                    </div>
                    <div>
                        <label>Data de Término</label>
                        <input type="date" v-model="localPrograma.dtFim"
                            @change="$emit('editar', 'dtFim', $event.target.value)">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { dataParaInput } from "@/utils/date";

export default {
    name: "ModalEditarPrograma",
    props: {
        mostrar: { type: Boolean, default: false },
        programa: { type: Object, default: () => ({}) },
        gerente: { type: Array, default: () => [] },
    },
    emits: ["fechar", "editar"],
    data() {
        return {
            localPrograma: {},
        };
    },
    watch: {
        programa: {
            handler(val) {
                if (val && Object.keys(val).length) {
                    this.localPrograma = {
                        ...val,
                        dtInicio: val.dtInicio ? dataParaInput(val.dtInicio) : "",
                        dtFim: val.dtFim ? dataParaInput(val.dtFim) : "",
                    };
                }
            },
            immediate: true,
            deep: true,
        },
        mostrar(visivel) {
            if (visivel && this.programa && Object.keys(this.programa).length) {
                this.localPrograma = {
                    ...this.programa,
                    dtInicio: this.programa.dtInicio ? dataParaInput(this.programa.dtInicio) : "",
                    dtFim: this.programa.dtFim ? dataParaInput(this.programa.dtFim) : "",
                };
            }
        },
    },
};
</script>
